export default function (title) {
  return encodeURIComponent(title.replace(/(<\/?([^>]+?)>)/g, ''))
}
